// export const ApiBaseUrl = (window as any).BASE_URL;
export const ApiBaseUrl = `${process.env.REACT_APP_API_END_POINT}`;
// export const ApiBaseUrl = "https://admin-api.core.refactor.golrangonline.ir";
// export const ApiBaseUrl = "https://admin-api.core.refactor2.golrangonline.ir";
//Local URL: https://localhost:7101
export const KycBaseUrl = "/api/Kyc";
export const BasicInformationBaseUrl = "/api/BasicInformation";
export const LoanBaseUrl = "/api/Loan";
export const SupplierBaseUrl = "/api/Supplier";
export const SupplierUserBaseUrl = "/api/SupplierUser";
export const SupplierPaymentBaseUrl = "/api/SupplierPayment";
//(process.env.NODE_ENV==='development')?"https://supp-api.core.test.golrangonline.ir":"production";
// todo new=========================================>>>>>>>>>>>new
export const AccountBaseUrl = "/api/Account";
export const CartableBaseUrl = "/api/Cartable";
export const PBIReportBaseUrl = "/api/PBIReport";
export const DashboardBaseUrl = "/api/Dashboard";
export const SupplierNoticeBaseUrl = "/api/SupplierNotice";
export const SecurityBaseUrl = "/api/Security";
export const ReportURL = "/api/Supplier";
export const MapURL = "/api/Map";
export const VehicleUrl = "/api/Vehicle";
export const BasePowerBIURL = "https://bi.golrangonline.ir/ReportServer";
export const CategoryBaseURL = "/api/Category";

export const LoanTemplateUrl = "/api/LoanTemplate";
export const ChatUrl = "/api/Chat";
export const StoreUrl = "/api/Store";
export const BranchUrl = "/api/Branch";
export const WalletUrl = "/api/Wallet";
export const ReportChequeURL = "/api/Report";
export const baseChequeProssesURL = "https://localhost:7101";
export const ChequeProssesURL = "/api/ChequeProsses";
export const OfficePosts = "/api/OfficePosts";
export const Role = "/api/Role";
export const Menu = "/api/Menu";
export const UserPermission = "/api/UserPermission";
export const UserReport = "/api/UserReport";
export const EnumUrl = "/api/Enum";
export const PermissionUrl = "/api/Permission";
export const OfficePostRole = "/api/OfficePostRole";
export const SettlementUrl = "/api/Settlement";
export const DropDownUrl = "/api/DropDown";
export const Sale = "/api/Sale";
export const Iban = "/api/Iban";
export const SupplierUser = "/api/SupplierUser";
export const Customer = "/api/Customer";
export const ChequeBaseUrl = "/api/Cheque";
export const PaymentUrl = "/api/Payment";
